/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Layout, SideBarToogle, SideLink, Box } from "@flexisaf/flexibull2";
import { Outlet, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logOutUser } from "../redux/authentication/reducer";
import Theme from "../theme";
import Logo from "../assets/saflearnlogo.svg";
import { menuList } from "../navMenu";

const AppLayout = ({ children }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const logOut = () => {
    dispatch(logOutUser());
    navigate("/login");
  };
  return (
    <>
      <Layout
        theme={Theme}
        withSideNav
        withTopNav
        sideNavProps={{
          float: window.innerWidth <= 480 ? true : false,
          background: "#FFF",
          brandHeight: "30px",
          borderline: Theme.PrimaryBorderColor,
          brand: (
            <SideBarToogle>
              <Box margin="0 0 0 4px">
                <img src={Logo} alt="saflearn" style={{ width: '150px'}} />
              </Box>
            </SideBarToogle>
          ),
          menuList,
        }}
        topNavProps={{ anchor: false }}
        sideNavCloseWidth="90px"
        sideNavOpenWidth="270px"
        topNavContent={<Box align="right" pad="20px"></Box>}
        sideNavContent={
          <Box
            style={{
              position: "absolute",
              bottom: "20px",
              left: "0",
            }}
          >
            <SideLink onClick={logOut}>
              <a style={{ cursor: "pointer" }}>
                <i className="saf-user" /> <span>Logout</span>
              </a>
            </SideLink>
          </Box>
        }
      >
        <Box pad="5rem 0">
          <Box pad="3rem 2rem">
            <Outlet />
          </Box>
        </Box>
      </Layout>
    </>
  );
};

export default AppLayout;
